"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecursiveMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
const RecursiveMenu = _ref => {
  let {
    children,
    catalogLinks,
    ownAssortment,
    previousTitle,
    title,
    href,
    openNextLevel,
    openPrevLevel,
    onLinkClick,
    text,
    className,
    companyName
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Header-ModalMenuWrapper', className);
  const CA_DISPLAY_LEVEL = 3;
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-ModalMenu"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item cds-ModalMenu-Item--Parent"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-Link cds-ModalMenu-Link--Parent cds-ModalMenu-Link--Arrow",
    href: "#",
    onClick: openPrevLevel
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-ModalMenu-ArrowIcon",
    name: _Icon.ICON_NAME.arrowLeft
  }), previousTitle)), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item cds-ModalMenu-Item--Current"
  }, title), href && /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item cds-ModalMenu-Item--SeeAll"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-Link",
    href: href,
    onClick: onLinkClick(href)
  }, text.seeAll))), children?.length > 0 && children.map(category => /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item",
    key: category.title
  }, category.children?.length > 0 ? /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-Link cds-ModalMenu-Link--Arrow",
    href: category.href,
    onClick: openNextLevel(title, category.children, category.href, category.title)
  }, category.title, category.hasCoreAssortment && category.level && !!(category.level >= CA_DISPLAY_LEVEL) && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.coreAssortment,
    size: _Icon.ICON_SIZE.small,
    className: "cds-ModalMenu-CAIcon"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-ModalMenu-ArrowIcon",
    name: _Icon.ICON_NAME.arrowRight
  })) : /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-Link",
    href: category.href,
    onClick: onLinkClick(category.href)
  }, /*#__PURE__*/_react.default.createElement("div", null, category.title, category.hasCoreAssortment && category.level && !!(category.level >= CA_DISPLAY_LEVEL) && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.coreAssortment,
    size: _Icon.ICON_SIZE.small,
    className: "cds-ModalMenu-CAIcon"
  }))))), (ownAssortment?.length > 0 || catalogLinks?.length > 0) && /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-ModalMenu-CatalogLinks"
  }, ownAssortment?.length > 0 && /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item",
    key: "own-assortment"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-OwnAssortmentLink cds-ModalMenu-Link--Arrow",
    href: ownAssortment[0].href,
    onClick: openNextLevel(title, ownAssortment[0].children, ownAssortment[0].href, ownAssortment[0].title)
  }, ownAssortment[0].title, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-ModalMenu-LinkSubtitle"
  }, companyName || '', /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-ModalMenu-CatalogLinkIcon",
    name: _Icon.ICON_NAME.printAndPromo,
    size: _Icon.ICON_SIZE.small
  })), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-ModalMenu-ArrowIcon",
    name: _Icon.ICON_NAME.arrowRight
  }))), catalogLinks?.length > 0 && catalogLinks.map(link => /*#__PURE__*/_react.default.createElement("li", {
    key: link.title
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-CatalogLink",
    href: link.href
  }, link.title, link.iconName && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-ModalMenu-CatalogLinkIcon",
    name: link.iconName,
    size: _Icon.ICON_SIZE.small
  })))))));
};
exports.RecursiveMenu = RecursiveMenu;
//# sourceMappingURL=RecursiveMenu.js.map